import { QueryKey, useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import qs from 'qs';
import { useMemo } from 'react';

import { createApiInstance } from '@/pages/Insights/Context/ApiContext';

interface UseBuildCacheInsightsApiQueryOptions<ResponseType, ErrorType = unknown> extends Omit<
  UseQueryOptions<AxiosResponse<ResponseType>, AxiosError<ErrorType>, ResponseType>,
  'queryKey' | 'queryFn'
> {
  requestConfig?: Omit<AxiosRequestConfig, 'url'>;
}

const useBuildCacheInsightsApiQuery = <ResponseType, ErrorType = unknown>(
  queryKey: QueryKey,
  url: string,
  traceToken: string,
  options?: UseBuildCacheInsightsApiQueryOptions<ResponseType, ErrorType>,
): UseQueryResult<ResponseType, AxiosError<ErrorType>> => {
  const api = useMemo(() => createApiInstance(traceToken), [traceToken]);

  const requestConfig = {
    paramsSerializer: {
      serialize: (params: string | Record<string | number, string | number | string[] | number[]>): string =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
    },
    ...options?.requestConfig,
  };
  return useQuery({
    queryKey: [queryKey, url, requestConfig],
    queryFn: () => api.get(url, requestConfig),
    select: (response) => response.data,
    ...options,
  });
};

export default useBuildCacheInsightsApiQuery;
